import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { decodeJWT } from '../../../services/candidateService';
import { serverConfig } from '../../../services/server-config';
import { CandidateService } from '../../../services/candidateService';
import fallbackProfileLogo from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';

const CandidateUserContext = createContext();

export const CandidateUserProvider = ({ children }) => {
  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [candidateStatus, setCandidateStatus] = useState("N");

  useEffect(() => {
    const fetchCandidateDetails = async () => {
      const decoded = decodeJWT(localStorage.getItem('authToken'));
      const candidateId = _.get(decoded, 'username', '');
      if (!candidateId) return;

      try {
        const res = await CandidateService.getCandidateById(candidateId);
        const data = _.get(res, 'data.candidates[0]', null);
        const personal = _.get(data, 'candidate.personalDetails', {});

        if (data) {
          const displayPicArray = Array.isArray(personal.displayPic) ? personal.displayPic : [];
          const dpPath = displayPicArray.length > 0 ? displayPicArray[0].path : null;

          setCandidate({
            id: data.candidateId,
            name: `${personal.firstName || ''} ${personal.lastName || ''}`.trim(),
            email: personal.primaryEmailId || '',
            phone: personal.primaryPhoneNumber || '',
            dpPath,
            imageBlobUrl: null,
          });
          if (data?.candidateApproved) {
            setCandidateStatus(data.candidateApproved);
          }
        }
      } catch (error) {
        console.error('Error fetching candidate details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCandidateDetails();
  }, []);

  useEffect(() => {
    const fetchProfileImage = async () => {
      if (!candidate || candidate.imageBlobUrl !== null) return;

      if (!candidate.dpPath || candidate.dpPath.startsWith('blob:')) {
        setCandidate((prev) => ({
          ...prev,
          imageBlobUrl: fallbackProfileLogo,
        }));
        return;
      }

      try {
        const response = await axios.get(
          `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${encodeURIComponent(candidate.dpPath)}`,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
            responseType: 'blob',
          }
        );

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const imageUrl = URL.createObjectURL(blob);

        setCandidate((prev) => ({
          ...prev,
          imageBlobUrl: imageUrl,
        }));
      } catch (error) {
        console.error('Error fetching candidate profile image:', error);
        setCandidate((prev) => ({
          ...prev,
          imageBlobUrl: fallbackProfileLogo,
        }));
      }
    };

    fetchProfileImage();
  }, [candidate]);

  return (
    <CandidateUserContext.Provider value={{
      candidate, setCandidate, loading, candidateStatus,
      setCandidateStatus,
    }}>
      {children}
    </CandidateUserContext.Provider>
  );
};

export const useCandidateUser = () => useContext(CandidateUserContext);